module.exports = __webpack_public_path__ + "static/media/registerPhoto.50b44fc4.svg";